import { Dashboard } from "../../../dashboards/components/Dashboard"
import { DeviceReport } from "../components/DeviceReport"

type HomeProps = Readonly<{}>

export function SupplierReportsHome({}: HomeProps) {
    return (
        <Dashboard>
            <DeviceReport />
        </Dashboard>
    )
}
